import React from "react";
import { observer } from "mobx-react";
import { TenantTokenUsageViewStore } from "../../store";
import { TenantTokenUsageViewForm } from "./TenantTokenUsageViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantTokenUsageViewProps = {
  tenantTokenUsageViewStore: TenantTokenUsageViewStore;
};

export const TenantTokenUsageView: React.FC<TenantTokenUsageViewProps> =
  observer(({ tenantTokenUsageViewStore }) => {
    return (
      <div>
        <TenantTokenUsageViewForm
          provider={tenantTokenUsageViewStore.providerValue}
          model={tenantTokenUsageViewStore.modelValue}
          promptTokens={tenantTokenUsageViewStore.promptTokensValue}
          completionTokens={tenantTokenUsageViewStore.completionTokensValue}
          totalTokens={tenantTokenUsageViewStore.totalTokensValue}
          conversationValue={tenantTokenUsageViewStore.conversationValue}
          conversationUserValue={
            tenantTokenUsageViewStore.conversationUserValue
          }
          timestamp={tenantTokenUsageViewStore.timestampValue}
          totalTimeMs={tenantTokenUsageViewStore.totalTimeMsValue}
          llmTimeMs={tenantTokenUsageViewStore.llmTimeMsValue}
          toolsTimeMs={tenantTokenUsageViewStore.toolsTimeMsValue}
          ragTimeMs={tenantTokenUsageViewStore.ragTimeMsValue}
          firstTokenMs={tenantTokenUsageViewStore.firstTokenMsValue}
          llmCallCount={tenantTokenUsageViewStore.llmCallCountValue}
          toolCallCount={tenantTokenUsageViewStore.toolCallCountValue}
          ragChunksCount={tenantTokenUsageViewStore.ragChunksCountValue}
          abTestCondition={tenantTokenUsageViewStore.abTestConditionValue}
          onPrint={(handlePrint: () => void) =>
            tenantTokenUsageViewStore.printTenantTokenUsage(handlePrint)
          }
          onCancel={() => tenantTokenUsageViewStore.cancelTenantTokenUsage()}
          onEdit={
            tenantTokenUsageViewStore.isEditEnabled
              ? () => tenantTokenUsageViewStore.editTenantTokenUsage()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantTokenUsageViewStore.errorDialogOpened}
          title={tenantTokenUsageViewStore.errorTitle}
          description={tenantTokenUsageViewStore.errorDescription}
          onClose={() => tenantTokenUsageViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
